import { render } from "./ConfusionMatrixPage.vue?vue&type=template&id=60947968"
import script from "./ConfusionMatrixPage.vue?vue&type=script&lang=js"
export * from "./ConfusionMatrixPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__